import * as React from 'react';

const styles = require('./GuideStickyFooter.scss');

interface Props {
    regionName: string;
    link: string;
}

export const GuideStickyFooter: React.FC<Props> = (props) => (
    <div className={styles.className}>
        <a className={styles.buttonLink} href={props.link}>
            {' '}
            Explore {props.regionName}
        </a>
    </div>
);

export default GuideStickyFooter;
